import React from 'react';
import { getNextActionHint } from '../../game/systems/tutorial';

export function NextActionBar({ state, dispatch }) {
  const hint = getNextActionHint(state);

  if (!hint || state.tutorial?.hintDismissed) return null;

  const handleNavigate = () => {
    if (hint.screen) {
      dispatch({ type: 'NAVIGATE', payload: { screen: hint.screen, roomId: hint.roomId } });
    }
  };

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      height: 44,
      background: 'var(--panel)',
      borderTop: '1px solid var(--border)',
      display: 'flex',
      alignItems: 'center',
      paddingLeft: 16,
      paddingRight: 16,
      gap: 12,
      zIndex: 800,
    }}>
      <span style={{ fontSize: 16 }}>{hint.icon}</span>
      <span style={{ fontSize: 12, color: 'var(--text-muted)', flex: 1 }}>
        {hint.isTutorial && <span style={{ color: 'var(--blue)', fontWeight: 600, marginRight: 6 }}>Tutorial:</span>}
        {hint.text}
      </span>
      {hint.screen && (
        <button
          className="btn btn-primary btn-sm"
          onClick={handleNavigate}
          style={{ fontSize: 11 }}
        >
          Go →
        </button>
      )}
      <button
        style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-dim)', fontSize: 14, padding: '0 4px' }}
        onClick={() => dispatch({ type: 'DISMISS_HINT' })}
        title="Dismiss hint"
        aria-label="Dismiss hint"
      >
        ✕
      </button>
    </div>
  );
}
